<template>
  <div class="topBar-container" :class='{mobile: mobileView}'>

    <i class="zmdi zmdi-search mobileSearch" v-if='mobileView' @click="$emit('showHideSide')"></i>

    <div class='logo' v-if='!mobileView'>
      <div class="logoImg" v-if='!isIe'>
        <img class='callBoxLogo' src="https://assets-cdn.carwars.com/platform_allies/header/nav-logo-cbm-desktop.png" v-if='!carwars'>
        <img class='carWarsLogo' src="https://assets-cdn.carwars.com/logos-2021/car-wars/svg/Car+Wars+Logo_Horizontal_Multi-White_Digital.svg" v-else>
        <span class="copyright">{{ currentYear }} CALL BOX. ALL RIGHTS RESERVED.</span>
      </div>
      <h1>Communication Dashboard</h1>
    </div>
    <div class='logo' v-else>
       <div class='logoImg' v-if='!isIe'>
        <img class='callBoxLogo' src="https://assets-cdn.carwars.com/websites/callbox/logos/cb.png" v-if='!carwars'>
        <img src="https://assets-cdn.carwars.com/platform_allies/header/CW-logo-icon-2016.svg" v-else>
        <span class="copyright">{{ currentYear }} CALL BOX. ALL RIGHTS RESERVED.</span>
      </div>
      <h2>Call Box</h2>
    </div>

    <button class="campaignButton" @click="openCampaign()" v-if='!mobileView && user && user.frn_lskinid'>Campaigns</button>

    <div class="topBar-content">
      <UserAvatar :user="user" :classStatus="classStatus" @avatar-clicked="loadProfileInfo(); showProfilePop()"></UserAvatar>
    </div>

    <ProfileEditPopup :showProfile="showProfile" :mobileView="mobileView" :user="user" :profile="profile" :classStatus="classStatus" :mxYouLink="mxYouLink" :textNotificationsOn="textNotificationsOn" :NotificationsOn="NotificationsOn" :serviceWorkerExists="serviceWorkerExists"
      @close-profile-pop="closeProfilePop()" @status-available='changeStatus("available")' @status-unavailable='changeStatus("unavailable")' @logout="routeToLogout()" @toggle-text-notes="toggleTextNotes()" @toggle-notes="toggleNotes()">
      <template v-slot:userNameInput>
        <input v-if='user.Phonecode' v-model='profile.userName'>
      </template>
      <template v-slot:userPhoneInput>
        <input id="DirectPhoneNumer" :class="{ error : incompletePhone || invalidPhone }" v-model='profile.userPhone' maxlength="12" type="tel">
        <p v-if='invalidPhone' class='error'> Direct phone number must not be an active tracking line. </p>
      </template>
      <template v-slot:userMobilePhoneInput>
        <input id="MobilePhoneNumer" :class="{ error : incompleteMobilePhone || invalidMobilePhone }" v-model='profile.userMobilePhone' @change="mobilePhoneValidation()" maxlength="12" type="tel">
        <p v-if='invalidMobilePhone' class='error'> Mobile phone number must not be an active tracking line. </p>
      </template>
      <template v-slot:button>
        <button :disabled="incompletePhone || incompleteMobilePhone || invalidPhone || invalidMobilePhone" @click="confirm()">Save</button>
      </template>
    </ProfileEditPopup>
  </div>
</template>

<script>
import $ from 'jquery'
import io from 'socket.io-client';
import axios from 'axios';
import { mapState, mapGetters } from 'vuex'
import firebase from 'firebase'
import { register } from 'register-service-worker'
import UserAvatar from '@/components/UserAvatar'
import ProfileEditPopup from '@/components/ProfileEditPopup'
require('../assets/css/topBar.css');

let messaging;
// Initialize Firebase
if('serviceWorker' in navigator && firebase.messaging.isSupported()){
	const firebaseConfig = {
		apiKey: "AIzaSyAJEE8BBD4Lii0nlmSWju2qf7nVo0irENU",
		authDomain: "notifications-api-230315.firebaseapp.com",
		projectId: "notifications-api-230315",
		messagingSenderId: "930487404826"
	};

	firebase.initializeApp(firebaseConfig);
	messaging = firebase.messaging();
	messaging.usePublicVapidKey("BNtSgZBNtki_efmsVvY0tXg4v4NGWSldRGsZ_t_NdDxBf9rI_CXYmDH7gi7FANBGsY8KD8CrOk5j1Cl4eTPxzSs");
	messaging.onMessage(function (payload) {
		showNotification(payload);
	});

	register('./service-worker.js', {
		registrationOptions: { scope: './' },
		ready (registration) {
			console.log('Service worker is active.')
		},
		registered (registration) {
			console.log('Service worker has been registered.')
		},
		cached (registration) {
			console.log('Content has been cached for offline use.')
		},
		updatefound (registration) {
			console.log('New content is downloading.')
		},
		updated (registration) {
			console.log('New content is available; please refresh.')
		},
		offline () {
			console.log('No internet connection found. App is running in offline mode.')
		}
	})
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function createNotification(payload) {
	return `
			<div class="toast__cell" data-clickaction=${payload.data.click_action}>
				<div class="toast toast--green" data-clickaction=${payload.data.click_action}>
					<img class="toast__icon" src="${payload.data.icon}" data-clickaction=${payload.data.click_action}/>
					<div class="toast__content">
						<p class="toast__type" data-clickaction=${payload.data.click_action}>${payload.data.title}</p>
						<p class="toast__message" data-clickaction=${payload.data.click_action}>${payload.data.body}</p>
					</div>
					<div class="toast__close">
						X
					</div>
				</div>
			</div>`;
}

async function showNotification(payload) {
	if (Notification) {
		await sleep(Math.random() * 10);
		if(localStorage.getItem("lastNotificationTime") !== payload.data.timestamp){
			localStorage.setItem("lastNotificationTime", payload.data.timestamp);
			var spawnedNotification = new Notification(
				payload.data.title, {
					body: payload.data.body,
					icon: payload.data.icon
				},
			);
			spawnedNotification.onclick = function () {
				window.open(payload.data.click_action);
			};
		}
	} else {
		var notificationBox = document.getElementById("notification-box");
		if (!notificationBox) {
			notificationBox = document.createElement("div");
			notificationBox.id = "notification-box";
			document.getElementsByTagName("body")[0].appendChild(notificationBox);
		}
		var notificationContainer = document.createElement("div");
		notificationContainer.classList.add("toast__container");
		notificationContainer.innerHTML = createNotification(payload);
		document.getElementById("notification-box").appendChild(notificationContainer);
	}
}

export default {
  name: 'topBar',
  props: ['currentView', 'waveformsArray', 'mobileView'],
  components: { UserAvatar, ProfileEditPopup },
  data: function () {
    return {
      agentSocket: io('wss://app-websocket.callbox.com/availability', { 'forceNew': true }),
      carwars: false,
      isIe: false,
      profile: {
        userStatus: '',
        userName: '',
        userPhone: '',
        userMobilePhone: ''
      },
      userInput: {
        newUserName: '',
        newUserPhone: '',
        newUserStatus: ''
      },
      classStatus: {
        available: false,
        workTime: false,
        notavailable: false,
        neutral: true
      },
      calling: { 
        name: 'Call Box', 
        num: '(123) 456-7891'
      },
      showProfile: false,
      showChange: false,
      NotificationsOn: false,
      textNotificationsOn: false,
      incompleteMobilePhone: false,
      incompletePhone: false,
      invalidPhone: false,
      invalidMobilePhone: false,
      token: "",
      campaignLink: ""
    }
  },
  computed: {
    ...mapState({
      socketOn: state => state.socketOn,
      user: state => state.user,
      userProfileData: state => state.userProfileData,
      hProduct: state => state.currentHproduct
    }),
    ...mapGetters([ 
      'mxYouLink',
      'lskins'
    ]),
    serviceWorkerExists: function(){
      return ('serviceWorker' in navigator && firebase.messaging.isSupported());
    },
    currentYear() {
    return new Date().getFullYear();
    },
    formattedPhoneNumber: function(){
      return this.profile.userPhone;
    },
    formattedMobilePhoneNumber: function(){
      return this.profile.userMobilePhone;
    }
  },
  beforeMount: function(){
    this.checkTokenStatus();
    this.getNotificationPermissions();
  },
  mounted: function() {
    this.agentSocket.on('connect', msg => {
      console.log('CLIENT: Availability Socket Connected');
    });

    this.agentSocket.on('test_message', msg => {
      if (msg.direct_number == this.userProfileData.phone) {
        this.$store.commit({
          type: 'setAvailabilityFromRedis',
          available: msg.available
        })
        this.loadProfileInfo();
      }
      if (typeof msg === 'string') {
        console.log('SERVER:', msg);
      }
    });

    let cwHProudcts = [1,3,11,12,16,17,20,21];
    let IntHProduct = parseInt(this.hProduct);
    this.carwars = cwHProudcts.indexOf(IntHProduct) !== -1;
    if(/*@cc_on!@*/false || !!document.documentMode){
      this.isIe = true;
    }
    this.getCampaignLink();
  },
  watch: {
    socketOn: function (val) {
      if (val) { this.startSocket(); this.loadProfileInfo() }
    },
    formattedPhoneNumber: function(val){
      if (val) {
        this.phoneValidation()
      }
    },
    formattedMobilePhoneNumber: function(val){
      if (val) {
        this.mobilePhoneValidation()
      }
    }
  },
  methods: {
    getCampaignLink: async function() {
      let loginLink = await this.axios.get(`/platform/${this.user.leuserid}`);
      loginLink = loginLink.data;
      let urlVars = loginLink.slice(loginLink.indexOf('Handler'));

      let domain, domainSource;

      if (this.hProduct == 2 || this.hProduct == 24) {
        domain = '//platform.callbox.com'
        domainSource = 'callbox.com'
      } else if (this.hProduct == 3) {
        domain = '//service.carwars.com'
        domainSource = 'service.carwars.com'
      } else if (this.hProduct == 4) {
        domain = '//calltrackeronline.com'
        domainSource = 'calltrackeronline.com'
      } else if (this.hProduct == 6) {
        domain = '//callmeasurement.com'
        domainSource = 'callmeasurement.com'
      } else if (this.hProduct == 7) {
        domain = '//servicehook.com'
        domainSource = 'servicehook.com'
      } else if (this.hProduct == 9) {
        domain = '//rentbuzz.com'
        domainSource = 'rentbuzz.com'
      } else /* hproduct IN (1,10,11,12) */ {
        domain = '//carwars.com'
        domainSource = 'carwars.com'
      }

      this.campaignLink = `//${domain}/platform_a/login2.cfm?${urlVars}&start_page=/platform_a/campaign.cfm&domain=${domainSource}&cbapp`;
    },
    openCampaign:function(){
      window.open(this.campaignLink, '_blank');
    },
    startSocket: async function() {
      await this.agentSocket.emit('join-room', this.lskins)
    },
    loadProfileInfo: function () {
      this.profile.userName = this.userProfileData.name
      this.profile.userPhone = this.userProfileData.directPhone
      this.profile.userMobilePhone = this.userProfileData.mobilePhone
      if (this.userProfileData.available == true) {
        this.profile.userStatus = 'available'
        this.classStatus.available = true;
        this.classStatus.workTime = false;
        this.classStatus.notavailable = false;
        this.classStatus.neutral = false;
      } else if (this.userProfileData.available == false) {
        this.profile.userStatus = 'unavailable'
        this.classStatus.available = false;
        this.classStatus.workTime = false;
        this.classStatus.notavailable = true;
        this.classStatus.neutral = false;
      } else {
        this.profile.userStatus = ''
        this.classStatus.available = false;
        this.classStatus.workTime = false;
        this.classStatus.notavailable = false;
        this.classStatus.neutral = true;
      }
    },
    updatePhone: async function () {
      let phone = this.profile.userPhone;
      let mobile = this.profile.userMobilePhone;

      const phoneMatch = ('' + phone).replace(/\D/g, '').match(/^\d{10}$/);
      const mobileMatch = ('' + mobile).replace(/\D/g, '').match(/^\d{10}$/);

      const phoneUpdate = (phone !== null && phone !== '' && phoneMatch);
      const mobileUpdate = (mobile !== null && mobile !== '' && mobileMatch);

      if(phoneUpdate || mobileUpdate){
        let endpoint = '/users/';
        endpoint = endpoint + this.user.Phonecode.phonecodeid + '/updateUserPhone';

        await this.axios.post(endpoint, {
          phone: phone ? phone.replace(/-/g, '') : null,
          mobile: mobile ? mobile.replace(/-/g, '') : null
        });

        if(phoneUpdate){
          this.$store.commit({
            type: 'updateUserPhone',
            phone: phone
          })
        }
        if(mobileUpdate){
          this.$store.commit({
            type: 'updateUserMobilePhone',
            mobilePhone: mobile
          })
        }

        await this.$store.dispatch('getUserProfileData', this.user.Phonecode.phonecodeid);
        this.loadProfileInfo();
      }
    },
    updateName: async function () {
      let nameInput = this.profile.userName
      if (nameInput !== null && nameInput !== '') {
        this.profile.userName = nameInput;
        this.userInput.newUserName = '';

        let endpoint = '/users/';
        endpoint = endpoint + this.user.Phonecode.phonecodeid + '/updateUserName';
        let res = await this.axios.post(endpoint, {
          name: nameInput
        });

        this.$store.commit({
          type: 'updateUserName',
          name: nameInput
        })

      } else {
        this.userInput.newUserName = '';
      }
    },
    updateStatus: async function () {
      let available = -1;
      this.profile.userStatus = this.userInput.newUserStatus;
      this.userInput.newUserStatus = '';

      if (this.profile.userStatus === 'unavailable') {
        available = 0;
      } else if (this.profile.userStatus === 'available') {
        available = 1;
      }

      if (available !== -1) {
        let endpoint = '/users/';
        endpoint = endpoint + this.user.Phonecode.phonecodeid + '/updateUserStatus';

        let res = await this.axios.post(endpoint, {
          lskinid: this.user.frn_lskinid,
          phone: this.userProfileData.phone,
          available: available
        });

        this.$store.commit({
          type: 'updateUserStatus',
          available: available
        })
      }
    },
    getNotificationPermissions: async function() {
      const endpoint = '/notifications/permissions/' + this.user.leuserid;
      let desktopAllowed = false;
      let textAllowed = false;

      await this.axios.get(endpoint)
        .then(function (response){
          desktopAllowed = (response.data.indexOf(1) > -1);
          textAllowed = (response.data.indexOf(3) > -1);
        });

      this.NotificationsOn = desktopAllowed;
      this.textNotificationsOn = textAllowed;
    },
    updateNotificationPermissions: async function() {
      // Desktop notifications
      if ('serviceWorker' in navigator) {
        if (this.NotificationsOn){
          await this.requestPermission()
        } else {
          await this.deleteToken(this.token);
        }
      }

      // All other notifications
      let notificationTypes = [];
      if(this.textNotificationsOn){
        notificationTypes.push(3);
      }

      let endpoint = '/notifications/permissions';

      await this.axios.post(endpoint, {
        notificationTypes: notificationTypes,
        userid: this.user.leuserid
      });
    },
    toggleNotes: function () {
  		this.NotificationsOn = !this.NotificationsOn;
    },
    toggleTextNotes: function () {
      this.textNotificationsOn = !this.textNotificationsOn;
    },
    phoneValidation: async function () {
      var Phone = this.profile.userPhone
      if (Phone.length > 0) {
        var cleaned = ('' + Phone).replace(/\D/g, '')
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            this.profile.userPhone = match[1] + '-' + match[2] + '-' + match[3]
            this.incompletePhone = false;

            let endpoint = '/ani/' + cleaned + '/internal'
            let internalTrackingLine = await this.axios.get(endpoint);
            if (internalTrackingLine.data) {
              this.invalidPhone = true;
            } else {
              this.invalidPhone = false;
            }
        } else if (cleaned.length < 10) {
            this.incompletePhone = true;
        }
        return null;
      }
    },
    mobilePhoneValidation: async function () {
      var Phone = this.profile.userMobilePhone
      if (Phone.length > 0) {
        var cleaned = ('' + Phone).replace(/\D/g, '')
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            this.profile.userMobilePhone = match[1] + '-' + match[2] + '-' + match[3]
            this.incompleteMobilePhone = false;

            let endpoint = '/ani/' + cleaned + '/internal'
            let internalTrackingLine = await this.axios.get(endpoint);
            if (internalTrackingLine.data) {
              this.invalidMobilePhone = true;
            } else {
              this.invalidMobilePhone = false;
            }
        } 
        else if (cleaned.length < 10) {
            this.incompleteMobilePhone = true;
        }
        return null
      }
    },
    saveChanges: async function () {
      this.updatePhone();
      this.updateName();
      this.updateStatus();
      this.updateNotificationPermissions();
    },
    pushToken: async function(){
      messaging.getToken().then(async (result) => {
        this.token = result
        let userToken = this.token;
        if (userToken !== null && userToken !== '') {
          let endpoint = '/notifications';
          let res = await this.axios.post(endpoint, {
            googleToken: userToken,
            userId: this.user.leuserid
          }).then(function(result){
            console.log(result)
          });
        }
      })
    },
    checkTokenStatus: async function(){
      this.token = this.getToken();
    },
    getToken: async function(){
      let endpoint = '/notifications/';
      endpoint += this.user.leuserid;
      this.axios.get(endpoint)
        .then((result) => {
          this.token = result.data.google_token;
          if(this.token && this.token.length){
              this.NotificationsOn = true;
          }
        });
    },
    deleteToken: async function(currentToken){
      if ('serviceWorker' in navigator) {
        messaging.deleteToken(currentToken)
          .then((result) => {
            this.token = "";
          })
        let endpoint = '/notifications/delete';

        let res = await this.axios.post(endpoint, {
          googleToken: currentToken,
          userId: this.user.leuserid
        }).then(function(result){
          console.log(result)
        });
      }
    },
    requestPermission: function () {
      if ('serviceWorker' in navigator) {
        messaging.requestPermission()
        .then(() => {
          navigator.serviceWorker.register('./static/firebase-messaging-sw.js')
          .then((registration) => {
            try{
              messaging.useServiceWorker(registration);
            } catch (e) {
              console.log(e);
            }
            messaging.getToken()
            .then((currentToken) => {
              this.token = currentToken;
              this.pushToken(currentToken);
            })
            .catch((err) => {
              console.log(err)
            });
          })
        });
      }
    },
    showProfilePop: function () {
      this.showProfile = true;
    },
    closeProfilePop: function () {
      this.showProfile = false;
      this.resetInput(this.profile.userStatus);
    },
    showChangePop: function () {
      this.showChange = true;
    },
    hideChangePop: function () {
      this.showChange = false;
    },
    changeStatus: function (status) {
      this.userInput.newUserStatus = status;
      if (status === 'unavailable') {
        this.classStatus.available = false;
        this.classStatus.workTime = false;
        this.classStatus.notavailable = true;
        this.classStatus.neutral = false;
      } else if (status === 'workTime') {
        this.classStatus.available = false;
        this.classStatus.workTime = true;
        this.classStatus.notavailable = false;
        this.classStatus.neutral = false;
      } else if (status === 'available') {
        this.classStatus.available = true;
        this.classStatus.workTime = false;
        this.classStatus.notavailable = false;
        this.classStatus.neutral = false;
      }
    },
    resetInput: function (status) {
      this.userInput.newUserName = '';
      this.userInput.newUserPhone = '';
      this.userInput.newUserStatus = '';
      if (status === 'unavailable') {
        this.classStatus.available = false;
        this.classStatus.workTime = false;
        this.classStatus.notavailable = true;
        this.classStatus.neutral = false;
      } else if (status === 'workTime') {
        this.classStatus.available = false;
        this.classStatus.workTime = true;
        this.classStatus.notavailable = false;
        this.classStatus.neutral = false;
      } else if (status === 'available') {
        this.classStatus.available = true;
        this.classStatus.workTime = false;
        this.classStatus.notavailable = false;
        this.classStatus.neutral = false;
      } else {
        this.classStatus.available = false;
        this.classStatus.workTime = false;
        this.classStatus.notavailable = false;
        this.classStatus.neutral = true;
      }
    },
    confirm: function () {
      this.saveChanges();
	    this.closeProfilePop();
    },
    routeToLogout: function () {
      this.$store.commit({
        type: 'setSessionLogout',
        sessionLogout: false
      })
      this.$router.push('logout');
    }
  }
}
</script>